module.exports = __webpack_public_path__ + "html/block-input.component.html";